<template>

  <form @submit.prevent="onSearch">
    <div class="row">
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div v-if="status && status.length">
          <SelectVue
              v-model="filters.status"
              :options="status"
              :is-clear="true"
              :placeholder="$t('placeholder.status')"/>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12" v-if="intrestedInDropdown && intrestedInDropdown.length">
        <SelectVue
            v-model="filters.interestedIn"
            :options="intrestedInDropdown"
            :is-clear="true"
            :placeholder="'Bereich'"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12" v-if="unemployedDropdown && unemployedDropdown.length">
        <SelectVue
            v-model="filters.lastName"
            :options="unemployedDropdown"
            :is-clear="true"
            :placeholder="$t('placeholder.last_name')"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12" v-if="officeDropdown && officeDropdown.length">
        <SelectVue
            v-model="filters.locationId"
            :options="officeDropdown"
            :is-clear="true"
            :placeholder="'Standort'"/>
      </div>
      <div class="col-lg-2 col-sm-12 col-12">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import SelectVue from '@/components/SelectVue.vue';
import {defineEmits, defineProps, toRefs} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const intrestedInDropdown = [
  {label: 'AMDL', value: 'AMDL'},
  {label: 'BeWo', value: 'BeWo'},
  {label: 'Sozio', value: 'Sozio'},
  {label: 'DRV', value: 'DRV'},
  {label: 'Sonstige', value: 'Sonstige'},
];

//const onUpdateStatus = (value) => {
//  filters.value.status = value ?? '';
//};
//
//const onUpdateInterestedIn = (value) => {
//  filters.value.interestedIn = value ?? '';
//};
//
//const onUpdateLastName = (value) => {
//  filters.value.lastName = value ?? '';
//};

const props = defineProps({
  unemployedDropdown: {
    type: Array,
    required: true,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  filters: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
  status: {
    type: Array,
    require: true,
  },
});

const emit = defineEmits(['search']);

// Use toRefs to maintain reactivity
const {filters} = toRefs(props);

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

</script>

<style scoped></style>